import { render } from "./DetilAbsensiView.vue?vue&type=template&id=4058510d"
import script from "./DetilAbsensiView.vue?vue&type=script&lang=js"
export * from "./DetilAbsensiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__